/* eslint-disable max-statements */
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

import {
	Address,
	Backdrop,
	Button,
	FullFlex,
	OutsideWrapper,
	SkinModal,
	Wrapper,
} from './styles';

const ShippingModal = ({
	show,
	verified_address,
	original_address,
	saveShippingInfo,
}) => {
	if (!show || !(verified_address && original_address)) {
		return null;
	}

	const stopProp = event => event.stopPropagation();

	useEffect(() => {
		if (document && window) {
			document.body.style.overflow = 'hidden';
		}
	},
	[]);

	return (
		ReactDOM.createPortal(
			<OutsideWrapper>
				<Backdrop fullScreen={true}>
					<SkinModal onClick={stopProp}>
						<Wrapper>
							<h1></h1>
							<FullFlex>
								<Address verified>
									<h1>Did you mean this address?</h1>
									<h2>{verified_address.name}</h2>
									<h2>{verified_address.address1}</h2>
									{verified_address.address2 && <h2>{verified_address.address2}</h2>}
									<h2>{verified_address.city}, {verified_address.state}</h2>
									<h2>{verified_address.zip}</h2>
									<Button onClick={() => saveShippingInfo('verified')}>
                    Use verified address
									</Button>
								</Address>
								<Address>
									<h1>You entered:</h1>
									<h2>{original_address.name}</h2>
									<h2>{original_address.address1}</h2>
									{original_address.address2 && <h2>{original_address.address2}</h2>}
									<h2>{original_address.city}, {original_address.state}</h2>
									<h2>{original_address.zip}</h2>
									<Button onClick={() => saveShippingInfo('original')}>
                    Use original address
									</Button>
								</Address>
							</FullFlex>
						</Wrapper>
					</SkinModal>
				</Backdrop>
			</OutsideWrapper>,
			document.body)
	);
};

ShippingModal.propTypes = {
	show: PropTypes.bool.isRequired,
	verified_address: PropTypes.object.isRequired,
	original_address: PropTypes.object.isRequired,
	saveShippingInfo: PropTypes.func.isRequired,
};

export default ShippingModal;
